export const pinItPinWidgetMetaData = {
    isRepeatable: false
}
